import { Option } from './components/Dialogs/FilePermissions'
import Docs from './icons/Google/Docs'
import Sheets from './icons/Google/Sheets'
import Slides from './icons/Google/Slides'
import Word from './icons/OneDrive/Word'
import Excel from './icons/OneDrive/Excel'
import Powerpoint from './icons/OneDrive/Powerpoint'
import GoogleDriveIcon from './icons/Google/GoogleDriveIcon'
import OneDriveIcon from './icons/OneDrive/OneDriveIcon'
import SharePointIcon from './icons/SharePointIcon'
export const ONE_DRIVE_LAUNCH_CONTEXT = 'Microsoft'
export const GOOGLE_DRIVE_LAUNCH_CONTEXT = 'Google'
export const GOOGLE_DRIVE_CONFIG_LAUNCH_CONTEXT = 'Google Drive'
export const ONE_DRIVE_CONFIG_LAUNCH_CONTEXT = 'Microsoft OneDrive'
export const SHAREPOINT_CONFIG_LAUNCH_CONTEXT = 'Microsoft SharePoint'
export const CONNECTORS_GOOGLE_FILE_TYPE_EXCEL = 'excel'
export const CONNECTORS_GOOGLE_FILE_TYPE_DOC = 'docx'
export const CONNECTORS_GOOGLE_FILE_TYPE_PPT = 'ppt'
export const MS_FILE_EXT_EXCEL = 'xls'
export const MS_FILE_EXT_DOC = 'doc'
export const MS_FILE_EXT_PPT = 'ppt'
export const MS_FILE_EXT_EXCELX = 'xlsx'
export const MS_FILE_EXT_DOCX = 'docx'
export const MS_FILE_EXT_PPTX = 'pptx'
export const MS_PDF = 'pdf'
export const PDF = 'pdf'
export const GOOGLE_FILE_EXT_EXCEL = 'application/vnd.google-apps.spreadsheet'
export const GOOGLE_FILE_EXT_DOC = 'application/vnd.google-apps.document'
export const GOOGLE_FILE_EXT_PPT = 'application/vnd.google-apps.presentation'
export const MS_GOOGLE_FILE_EXT_EXCEL =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
export const MS_GOOGLE_FILE_EXT_DOCX =
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
export const MS_GOOGLE_FILE_EXT_PPTX =
  'application/vnd.openxmlformats-officedocument.presentationml.presentation'
export const GOOGLE_PDF = 'application/pdf'
export const MS_EXTERNAL_EMAILS_EXCLUSION_REASON =
  'your account not being internal to the presenter’s organization. Please check your email for the file invitation'
export const GOOGLE_APPS_SCRIPT = 'application/vnd.google-apps.script'
// TODO: research to get actual mime type of maps, sites
// export const GOOGLE_MY_MAPS =
//   'application/vnd.google-apps.drive-sdk.796396377186'
// export const GOOGLE_SITES = 'application/vnd.google-apps.drive-sdk.897606708560'
export const GOOGLE_DRAWINGS = 'application/vnd.google-apps.drawing'
export const GOOGLE_JAMBOARD = 'application/vnd.google-apps.jam'
export const GOOGLE_FORMS = 'application/vnd.google-apps.form'
export const GOOGLE_QUICK_VIDEO = 'video/quicktime'
export const GOOGLE_VIDEO_MP4 = 'video/mp4'
export const MS_OLD_GOOGLE_FILE_EXT_DOC = 'application/msword'
export const MS_OLD_GOOGLE_FILE_EXT_EXCEL = 'application/vnd.ms-excel'
export const MS_OLD_GOOGLE_FILE_EXT_PPT = 'application/vnd.ms-powerpoint'
export const GOOGLE_OPEN_DOCUMENT_TEXT =
  'application/vnd.oasis.opendocument.text'
export const GOOGLE_OPEN_DOCUMENT_PRESENTATION =
  'application/vnd.oasis.opendocument.presentation'
export const GOOGLE_OPEN_DOCUMENT_SPREADSHEET =
  'application/vnd.oasis.opendocument.spreadsheet'
export const GOOGLE_WEBPAGE = 'text/html'
export const GOOGLE_RICHTEXT = 'text/rtf'
export const GOOGLE_PLAINTEXT = 'text/plain'
export const GOOGLE_PNG_IMAGE = 'image/png'
export const GOOGLE_JPEG_IMAGE = 'image/jpeg'
export const GOOGLE_SVG_IMAGE = 'image/svg+xml'
// these are the types we will use to only show in google picker
export const COLLAB_SUPPORTED_GOOGLE_FILE_TYPES = [
  GOOGLE_FILE_EXT_DOC,
  GOOGLE_FILE_EXT_PPT,
  GOOGLE_FILE_EXT_EXCEL,
  MS_GOOGLE_FILE_EXT_DOCX,
  MS_GOOGLE_FILE_EXT_EXCEL,
  MS_GOOGLE_FILE_EXT_PPTX,
  MS_OLD_GOOGLE_FILE_EXT_PPT,
  MS_OLD_GOOGLE_FILE_EXT_DOC,
  MS_OLD_GOOGLE_FILE_EXT_EXCEL,
  // GOOGLE_DRAWINGS,
  // GOOGLE_FORMS,
]

export const TOPBAR_HEIGHT = 60
export const COLLABORATION_BANNER_HEIGHT = 64

/**
 * Below constants are for Microsoft File types that support screen sharing and Collaboration
 */
export const MS_VSD = 'vsd'
export const MS_VSDX = 'vsdx'
export const MS_ODT = 'odt'
export const MS_ODS = 'ods'
export const MS_ODP = 'odp'

/**
 * Below constants are for Microsoft File types that support screen sharing only
 */
export const MS_TXT = 'txt'
export const MS_RTF = 'rtf'
export const MS_PNG = 'png'
export const MS_JPEG = 'jpeg'
export const MS_HTML = 'html'
export const MS_CSV = 'csv'
export const MS_MP4 = 'mp4'
export const MS_GIF = 'gif'
export const MS_JPG = 'jpg'
export const MS_JPE = 'jpe'
export const MS_SHARE_ONLY_TYPES = [
  MS_TXT,
  MS_RTF,
  MS_PNG,
  MS_JPEG,
  MS_HTML,
  MS_PDF,
  MS_CSV,
  MS_MP4,
  MS_GIF,
  MS_JPG,
  MS_JPE,
]

/**
 * Used as a map between the file extensions provided by file picker and the file types expected
 * by the connectors API
 */
export const MapFileTypes = {
  [GOOGLE_FILE_EXT_DOC]: CONNECTORS_GOOGLE_FILE_TYPE_DOC,
  [GOOGLE_FILE_EXT_PPT]: CONNECTORS_GOOGLE_FILE_TYPE_PPT,
  [GOOGLE_FILE_EXT_EXCEL]: CONNECTORS_GOOGLE_FILE_TYPE_EXCEL,
  [MS_OLD_GOOGLE_FILE_EXT_EXCEL]: MS_FILE_EXT_EXCEL,
  [MS_GOOGLE_FILE_EXT_EXCEL]: MS_FILE_EXT_EXCELX,
  [MS_OLD_GOOGLE_FILE_EXT_DOC]: MS_FILE_EXT_DOC,
  [MS_GOOGLE_FILE_EXT_DOCX]: MS_FILE_EXT_DOCX,
  [MS_OLD_GOOGLE_FILE_EXT_PPT]: MS_FILE_EXT_PPT,
  [MS_GOOGLE_FILE_EXT_PPTX]: MS_FILE_EXT_PPTX,
  [GOOGLE_PDF]: PDF,
  [GOOGLE_APPS_SCRIPT]: GOOGLE_APPS_SCRIPT,
  [GOOGLE_DRAWINGS]: GOOGLE_DRAWINGS,
  [GOOGLE_JAMBOARD]: GOOGLE_JAMBOARD,
  [GOOGLE_FORMS]: GOOGLE_FORMS,
  [MS_FILE_EXT_DOC]: MS_FILE_EXT_DOC,
  [MS_FILE_EXT_EXCEL]: MS_FILE_EXT_EXCEL,
  [MS_FILE_EXT_PPT]: MS_FILE_EXT_PPT,
  [MS_FILE_EXT_DOCX]: MS_FILE_EXT_DOCX,
  [MS_FILE_EXT_EXCELX]: MS_FILE_EXT_EXCELX,
  [MS_FILE_EXT_PPTX]: MS_FILE_EXT_PPTX,
  [MS_PDF]: PDF,
  [MS_ODP]: MS_ODP,
  [MS_ODT]: MS_ODT,
  [MS_ODS]: MS_ODS,
  [MS_VSDX]: MS_VSDX,
  [MS_VSD]: MS_VSD,
  [MS_TXT]: MS_TXT,
  [MS_RTF]: MS_RTF,
  [MS_PNG]: MS_PNG,
  [MS_JPEG]: MS_JPEG,
  [MS_HTML]: MS_HTML,
  [MS_CSV]: MS_CSV,
  [MS_MP4]: MS_MP4,
  [MS_GIF]: MS_GIF,
  [MS_JPG]: MS_JPG,
  [MS_JPE]: MS_JPE,
}
export const DriveIconsConstant = {
  [ONE_DRIVE_CONFIG_LAUNCH_CONTEXT]: <OneDriveIcon />,
  [GOOGLE_DRIVE_CONFIG_LAUNCH_CONTEXT]: <GoogleDriveIcon />,
  [SHAREPOINT_CONFIG_LAUNCH_CONTEXT]: <SharePointIcon />,
}

export const FILE_PICKER_ZOOMDEV_HOST = 'za-filepicker.zoomdev.us'
export const FILE_PICKER_GO_HOST = 'za-filepicker-go.zoom.us'
export const FILE_PICKER_DG01_HOST = 'za-filepicker-review.zoom.us'
export const FILE_PICKER_PROD_HOST = 'za-filepicker.zoom.us'

export const GET_MEETING_INVITEE_DETAILS_FAILED =
  'We were unable to grant edit access to meeting invitees.'

export const COLLABORATION_NOT_SUPPORTED_MORE_PEOPLE_IN_MEETING = `Collaboration is not supported because there are too many participants in your meeting.`

export const COLLABORATION_NOT_SUPPORTED_NO_EDIT_PERMISSIONS = `You cannot collaborate on this document because you do not have edit access.`

export const COLLABORATION_NOT_SUPPORTED_IN_THIS_MEETING =
  'This meeting does not support collaboration.'

export const COLLABORATION_NOT_SUPPORTED_FILE_TYPE = `This file doesn't support collaboration`

export const COLLABORATION_LIMIT = 25

export const MappedFileTypes = {
  [CONNECTORS_GOOGLE_FILE_TYPE_DOC]: MS_FILE_EXT_DOC,
  [CONNECTORS_GOOGLE_FILE_TYPE_EXCEL]: MS_FILE_EXT_EXCEL,
  [CONNECTORS_GOOGLE_FILE_TYPE_PPT]: MS_FILE_EXT_PPT,
  [MS_FILE_EXT_DOC]: MS_FILE_EXT_DOC,
  [MS_FILE_EXT_EXCEL]: MS_FILE_EXT_EXCEL,
  [MS_FILE_EXT_EXCELX]: MS_FILE_EXT_EXCEL,
  [MS_FILE_EXT_PPTX]: MS_FILE_EXT_PPT,
} as const

export const StaticFileIconsConstant = {
  [GOOGLE_DRIVE_LAUNCH_CONTEXT]: {
    [CONNECTORS_GOOGLE_FILE_TYPE_DOC]: <Docs />,
    [CONNECTORS_GOOGLE_FILE_TYPE_EXCEL]: <Sheets />,
    [CONNECTORS_GOOGLE_FILE_TYPE_PPT]: <Slides />,
    [MS_FILE_EXT_DOC]: <Docs />,
    [MS_FILE_EXT_PPTX]: <Slides />,
    [MS_FILE_EXT_EXCEL]: <Sheets />,
    [MS_FILE_EXT_EXCELX]: <Sheets />,
    [GOOGLE_OPEN_DOCUMENT_TEXT]: <Word />,
    [GOOGLE_OPEN_DOCUMENT_PRESENTATION]: <Powerpoint />,
    [GOOGLE_OPEN_DOCUMENT_SPREADSHEET]: <Excel />,
  },
  [ONE_DRIVE_LAUNCH_CONTEXT]: {
    [MS_FILE_EXT_DOCX]: <Word />,
    [MS_FILE_EXT_DOC]: <Word />,
    [CONNECTORS_GOOGLE_FILE_TYPE_PPT]: <Powerpoint />,
    [MS_FILE_EXT_EXCELX]: <Excel />,
    [MS_FILE_EXT_EXCEL]: <Excel />,
    [MS_FILE_EXT_PPTX]: <Powerpoint />,
    [MS_ODP]: <Powerpoint />,
    [MS_ODT]: <Word />,
    [MS_ODS]: <Excel />,
  },
}

export const CLOSE_WEBVIEW_DURATION = 3600000 //1 hour in milliseconds

export const MS_MESSAGE_INIT = 'initialize'
export const MS_EVENT_LISTENER_MESSAGE = 'message'
export const MS_MESSAGE_TYPE_ACTIVATE = 'activate'
export const MS_MESSAGE_TYPE_NOTIFICATION = 'notification'
export const MS_MESSAGE_TYPE_COMMAND = 'command'
export const MS_MESSAGE_TYPE_ACK = 'acknowledge'
export const MS_MESSAGE_TYPE_RESULT = 'result'
export const MS_RESULT_TOKEN = 'token'
export const MS_RESULT_ERROR = 'error'
export const MS_RESULT_SUCCESS = 'success'
export const MS_ERROR_UNSUPPORTED_COMMAND = 'unsupportedCommand'

export const MS_COMMAND_AUTHENTICATE = 'authenticate'
export const MS_COMMAND_CLOSE = 'close'
export const MS_COMMAND_PICK = 'pick'

export const MS_NOTIFICATION_PAGE_LOADED = 'page-loaded'
export const MS_NOTIFICATION_ERROR_GENERIC = 'generic picker load error'

export const LOCAL_STORAGE_REFRESH_KEY = 'REFRESH'

export const DRIVE_NAME_GOOGLE = 'Google Drive'
export const DRIVE_PROVIDER_NAME_GOOGLE = 'Google'
export const DRIVE_NAME_ONE_DRIVE = 'OneDrive'
export const DRIVE_PROVIDER_NAME_ONE_DRIVE = 'Microsoft'
export const DRIVE_NAME_SHARE_POINT = 'Sharepoint'

export const MS_ERROR_CODES_WHITELIST = ['Interrupted']

export const IS_QUICK_ACCESS_ENABLED = true
export const Error_Screen_Drive_Name_Map = {
  [GOOGLE_DRIVE_CONFIG_LAUNCH_CONTEXT]: DRIVE_PROVIDER_NAME_GOOGLE,
  [ONE_DRIVE_CONFIG_LAUNCH_CONTEXT]: 'Onedrive', // Not using the DRIVE_NAME_ONE_DRIVE because it is spelled differently than what is being used in production for telemetry. Changing the spelling would create inconsistencies in the error messages
  [SHAREPOINT_CONFIG_LAUNCH_CONTEXT]: DRIVE_NAME_SHARE_POINT,
}

export const googlePermissionsOptions: Option[] = [
  { label: 'Viewer', value: 'viewer', verb: 'view' },
  { label: 'Commenter', value: 'commenter', verb: 'comment' },
  { label: 'Editor', value: 'editor', verb: 'edit' }, // default
]
export const msPermissionsOptions: Option[] = [
  { label: 'Viewer', value: 'viewer', verb: 'view' },
  { label: 'Editor', value: 'editor', verb: 'edit' }, // default
]

export function valueToVerb(
  label: 'viewer' | 'commenter' | 'editor'
): 'view' | 'comment' | 'edit' {
  const valueToVerb = {
    viewer: 'view',
    commenter: 'comment',
    editor: 'edit',
  } as const

  return valueToVerb[label] || 'edit'
}

export const GOOGLE_DRIVE_APP_NAME = 'google'
export const OFFICE_APP_NAME = 'microsoft'
